import { SET_ACCOUNT_HISTORY } from '../../actions';
export default function accountHistoryReducer(state, action) {
    switch (action.type) {
        case SET_ACCOUNT_HISTORY:
            return Object.assign(Object.assign({}, state), { accountHistory: action.payload.accountHistory });
        default:
            return state;
    }
}
